"use strict";

module.exports = function (
    departments,
    clients,
    $uibModal,
    $state,
    dialog,
    $translate,
    Department,
    Authentication
) {
    var _this = this;
    this.departments = departments;

    _this.clients = clients;
    this.deleteDepartment = function (department) {
        dialog
            .confirm({
                title: $translate.instant("DASHBOARD.DASH_DEPTS.DIAG_DEL.TITLE"),
                body: $translate.instant("DASHBOARD.DASH_DEPTS.DIAG_DEL.BODY"),
                accept: $translate.instant("DASHBOARD.DELETE"),
                cancel: $translate.instant("DASHBOARD.CANCEL"),
                size: "sm",
            })
            .then(function () {
                Department.deleteById({
                    id: department.id,
                })
                    .$promise.then(function () {
                        Authentication.loadDepartments(true)
                            .then(function (departments) {
                                _this.departments = departments;
                                // console.log('departments', departments)
                            });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
    };

    this.editDepartment = function (department) {
        // console.log(1);
        $uibModal
            .open({
                animation: true,
                controller: [
                    "$uibModalInstance",
                    "Department",
                    "clients",
                    "Authentication",
                    function ($uibModalInstance, Department, clients, Authentication) {
                        var _this = this;
                        this.Authentication = Authentication;

                        // console.log('clients', clients);

                        _this.clients = clients.filter(clt => (Authentication.isAuthorized(['admin']) || clt.owners.find(owner => owner.id == Authentication.currentUser())))
                        if (department)
                            this.department = JSON.parse(JSON.stringify(department));
                        else
                            this.department = {
                                name: null,
                                description: null,
                            };

                        this.create = function () {
                            if (!_this.department.name) {
                                return;
                            }

                            _this.loading = true;
                            Department.upsert(_this.department)
                                .$promise.then(function (department) {
                                    // console.log('department', department);
                                    $uibModalInstance.close({ department: department, reload: true });
                                })
                                .catch(function (error) {
                                    _this.loading = false;
                                    console.log(error);
                                });
                        };
                    },
                ],
                templateUrl:
                    "dashboard-departments/dashboardCreateDepartmentModal.html",
                controllerAs: "modal",
                size: "sm",
                windowClass: "dialog",
                bindToController: true,
                resolve: {
                    clients: function () {
                        return _this.clients;
                    },
                },
            })
            .result.then((result) => {
                // console.log('result', result);
                if (result.reload) {
                    Authentication.loadDepartments(true)
                        .then(function (departments) {
                            _this.departments = departments;
                            // console.log('departments', departments)
                        });
                }
            }, function () { //dismiss
            });
    };
};
